module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"You\u0027ve left the meeting","description":"You have successfully left the video interview. Thank you for your time.","rejoin":"Return\\nto meeting","action":"Go\\nto Huntica"}}')
  delete Component.options._Ctor
}
